import React from 'react';
import {
	DialogHeader,
	DialogHeaderImage,
} from '../../../../../shared/components/dialog';
import { IParkingProduct } from '../../../../domain/parking-product/models/IParkingProduct';

interface IParkingProductDetailsHeaderProps {
	parkingProduct: IParkingProduct;
	onSelectProductClick: () => void;
	buttonLabel: string;
}

export const ParkingProductDetailsHeader = ({
	parkingProduct,
	onSelectProductClick,
	buttonLabel,
}: IParkingProductDetailsHeaderProps) => {
	if (!parkingProduct.logo) {
		return <DialogHeader wideContent title={parkingProduct.name} />;
	}

	const button = parkingProduct.availability.isAvailable
		? {
				label: buttonLabel,
				onClick: onSelectProductClick,
		  }
		: undefined;

	return (
		<DialogHeaderImage
			imageSrc={parkingProduct.logo}
			imageAlt={parkingProduct.name}
			title={parkingProduct.name}
			loyaltyPoints={parkingProduct.loyaltyPoints}
			wideContent
			cropImage
			button={button}
		/>
	);
};
